<template>
  <div class="py-3 h-100">
    <div class="d-flex justify-content-between align-items-center">
      <p class="my-4">Work Order</p>
      <div v-if="modelsIsValid">
        <button class="btn btn-success mx-1" @click="submitWO">Submit</button>
        <button class="btn btn-danger mx-1" @click="cancelAttachment">
          Cancel
        </button>
      </div>
    </div>

    <div class="w-100 h-100" v-if="wo.file">
      <div class="form-group w-25 mb-3">
        <label class="small mb-1"> Contractor </label>
        <p class="form-control mb-0">
          {{ wo.contractor || "n/a" }}
        </p>
      </div>

      <label class="small mb-1">Start Date</label>
      <div class="input-group w-25 mb-3" @click="showDatetimeSelector = true">
        <span class="input-group-text border-dark">
          <i class="fa-solid fa-calendar-alt" />
        </span>
        <p class="form-control border-dark mb-0">
          {{ Helper.formatDate(wo.startDate, false) || "n/a" }}
        </p>
      </div>

      <!-- <iframe
        v-if="wo.file && wo.file.url"
        :src="Helper.formatMediaUrl(wo.file)"
        class="w-100 h-100"
        frameborder="0"
      /> -->

      <div class="mb-3 mt-5">
        <label class="d-block small mb-1">WO File</label>
        <div
          class="image-grid image-grid-placeholder border-0 bg-dark"
          v-if="wo.file && wo.file.url"
        >
          <button
            class="btn btn-dark h-100 w-100 lh-sm"
            @click="currentPdf = Helper.formatMediaUrl(wo.file)"
          >
            <i class="fa-solid fa-file-pdf fa-2x mb-2 d-block" />
            Click to view
          </button>
        </div>
      </div>
    </div>
    <div class="w-100 h-100" v-if="!wo.file">
      <div class="form-group w-25 mb-3">
        <label class="small mb-1">
          Contractor<sup class="text-danger">*</sup>
        </label>
        <select
          id="contractor"
          class="form-select form-select-sm"
          v-model="models.contractor"
        >
          <option :value="null" disabled>-- Select contractor</option>
          <option :value="contractor.id" v-for="contractor in contractors">
            {{ contractor.name }}
          </option>
        </select>
      </div>

      <label class="small mb-1">
        Start Date<sup class="text-danger">*</sup>
      </label>
      <div class="input-group w-25 mb-5" @click="showDatetimeSelector = true">
        <span class="input-group-text border-dark">
          <i class="fa-solid fa-calendar-alt" />
        </span>
        <input
          type="text"
          class="form-control border-dark"
          readonly
          style="cursor: pointer"
          :value="Helper.formatDate(models.startDate, false)"
        />
      </div>

      <div class="image-grid image-grid-placeholder" v-if="!filePreview">
        <button class="btn h-100 w-100 fw-bold lh-sm" @click="addFile()">
          <i class="fa-solid fa-file-upload mb-3 d-block" />
          Upload PDF
        </button>
      </div>

      <iframe
        v-if="filePreview"
        :src="filePreview"
        class="w-100 h-100"
        frameborder="0"
      />
    </div>

    <datetime-selector
      v-if="showDatetimeSelector"
      :date="models.startDate"
      @close="dateSelected"
    />

    <pdf-viewer
      :url="currentPdf"
      v-if="currentPdf"
      @close="currentPdf = null"
    />
  </div>
</template>

<script>
import Swal from "sweetalert2";
import PdfViewer from "@/components/PdfViewer";
import AddMaterialForm from "@/components/AddMaterialForm";
import DatetimeSelector from "@/components/DatetimeSelector";

export default {
  props: ["componentId", "status", "pavementId"],
  components: { AddMaterialForm, DatetimeSelector, PdfViewer },
  data() {
    return {
      showDatetimeSelector: false,
      wo: {
        file: null,
        contractor: null,
        startDate: null,
      },
      filePreview: null,
      fileInput: null,
      invalidFields: [],
      contractors: [],
      models: {
        startDate: null,
        contractor: null,
      },
      currentPdf: null,
    };
  },
  computed: {
    modelsIsValid() {
      return (
        Object.keys(this.models).every((key) => this.models[key]) &&
        this.fileInput
      );
    },
  },
  methods: {
    dateSelected(e) {
      if (e) {
        this.models.startDate = e;
      }

      this.showDatetimeSelector = false;
    },
    cancelAttachment() {
      this.fileInput = null;

      this.filePreview = null;

      Object.keys(this.models).forEach((key) => {
        this.models[key] = null;
      });

      this.Helper.removeToast("Work order PDF removed");
    },
    submitWO() {
      Swal.fire({
        icon: "question",
        title: "<h5 class='fw-bold'>Submit work order data?</h5>",
        html: "<p class='mb-0'>This action is not reversible.<br />Data cannot be changed after it is submitted.</p>",
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: "Confirm",
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.Helper.toggleLoadingSpinner(true);

          await this.uploadFileInput();

          const selectedContractor = this.contractors.find(
            (contractor) => contractor.id == this.models.contractor
          );

          await this.API.put(`pavement-cases/${this.pavementId}`, {
            wo_contractor: selectedContractor?.name,
            wo_startDate: this.models.startDate,
          });

          await this.getWo();

          this.Helper.toggleLoadingSpinner(false);

          this.fileInput = null;

          this.filePreview = null;

          Object.keys(this.models).forEach((key) => {
            this.models[key] = null;
          });

          this.triggerAlert("success", "WO uploaded", "componentIsCompleted");
        }
      });
    },
    async uploadFileInput() {
      return new Promise(async (resolve, reject) => {
        let fileModels = {
          ref: "pavement-case",
          refId: this.pavementId,
          field: "wo",
          files: "",
        };

        const formData = new FormData();

        Object.keys(fileModels).forEach((key) => {
          if (key != "files") {
            formData.append(key, fileModels[key]);
          } else {
            formData.append("files", this.fileInput, this.fileInput.name);
          }
        });

        const [call, error] = await this.Helper.handlePromise(
          this.API.postForm("upload", formData)
        );

        if (error) {
          console.error(error);

          return reject(error);
        } else {
          return resolve("OK");
        }
      });
    },
    triggerAlert(icon, text, callback, callbackData) {
      Swal.fire({
        icon: icon,
        title: `<h5>${text}</h5>`,
      }).then(() => {
        if (callback) {
          this.$emit(callback, callbackData);
        }
      });
    },
    addFile() {
      const input = document.createElement("input");

      input.type = "file";

      input.multiple = false;

      input.accept = "application/pdf";

      input.onchange = this.fileChanged;

      input.click();
    },
    fileChanged(e) {
      const files = e.target.files;
      if (!files || !files.length) return;

      Object.values(files).forEach((file) => {
        const reader = new FileReader();

        reader.readAsDataURL(file);

        reader.onload = (readerEvent) => {
          this.fileInput = file;

          this.filePreview = readerEvent.target.result;
        };
      });

      this.Helper.successToast("Work order PDF added");
    },
    async getContractors() {
      return new Promise(async (resolve, reject) => {
        const _contractorsName = ["EDGENTA PROPEL BHD", "SRM SETIA SDN BHD"];

        let query = "name_in=" + _contractorsName.join("&name_in=");

        const [call, error] = await this.Helper.handlePromise(
          this.API.get(`contractors?${query}`)
        );

        if (error) {
          console.error(error);

          reject(error);
        } else {
          this.contractors = call.data;

          resolve();
        }
      });
    },
    async getWo() {
      if (this.pavementId) {
        this.Helper.toggleLoadingSpinner(true);

        const [call, error] = await this.Helper.handlePromise(
          this.API.get(`pavement-cases/${this.pavementId}`)
        );

        if (error) {
          this.triggerAlert("error", "Error getting WO data");
        } else {
          this.wo.file = call.data.wo;

          this.wo.contractor = call.data.wo_contractor;

          this.wo.startDate = call.data.wo_startDate;
        }

        this.Helper.toggleLoadingSpinner(false);
      }
    },
  },
  async mounted() {
    this.Helper.toggleLoadingSpinner(true);

    await this.getWo();

    if (!this.wo.file && !this.contractors.length) {
      await this.getContractors();
    }

    this.Helper.toggleLoadingSpinner(false);
  },
};
</script>